
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/tradewind-careers",
      function () {
        return require("private-next-pages/about-us/tradewind-careers/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/tradewind-careers"])
      });
    }
  